import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    root:{
        display:'flex',
        height: '100%',
        position: 'relative',   
        backgroundColor:'#f3f9fb',
        textAlign:'center',
        [theme.breakpoints.down("xs")]: {
            
        },
    },
    media: {
        height: '100px',
        width:'20%',
        padding:'0.5%',
        cursor:'pointer'
    },
    name:{  
        width:'25%',
        padding:'0.5%',
        textAlign:'start',
    },
    title:{
        cursor:'pointer',
        display:'inline'
    },
    title1:{
        display:'inline-block',
    },
    description:{
        display:'flex',
        width:'80%',
        height:'50%',
    },
    description2:{
        wordWrap:'break-word',
        width:'100%'
    },
    price:{
        textAlign:'center',
        width:'15%',
        padding:'0.5%',
        color:'#3f51b5',
        [theme.breakpoints.down("xs")]: {
            paddingRight:'5.5%'
        },
    },
    city:{
        width:'12%',
        padding:'0.5%',
    },
    category:{
        width:'12%',
        padding:'0.5%',
        [theme.breakpoints.down("xs")]: {
            paddingLeft:'10%'
        },
    },
    edit:{
        width:'11%',
        padding:'0.5%',
        justifyContent:'center',
        [theme.breakpoints.down("xs")]: {
           display:'none'
        },
    }
})
);